/**
 * Refuse a URL scheme the browser must not follow.
 *
 * Neither a bound `:href` nor `window.open` sanitises its value, so a
 * `javascript:` or `data:` URL runs as script in this origin.
 */

/** `http:` stays allowed: development and test serve the API over plain HTTP. */
const SAFE_URL_SCHEMES: readonly string[] = ['http:', 'https:'];

/** Only so `URL` can parse a relative href, which names no scheme and is safe. */
const RELATIVE_URL_BASE = 'https://relative.invalid/';

/** Parsed, not matched: `URL` normalises an obfuscated scheme like `java\nscript:`. */
export function isSafeUrl(value: string | null | undefined): boolean {
    // Read off an unvalidated JSON response, so the declared type is an assertion.
    // `new URL(undefined, base)` would resolve to a safe-looking relative path.
    if (typeof value !== 'string' || value === '') {
        return false;
    }

    try {
        return SAFE_URL_SCHEMES.includes(new URL(value, RELATIVE_URL_BASE).protocol);
    } catch {
        return false;
    }
}
